export default "__VITE_ASSET__BhVmcbLR__"